
import * as React from 'react';
import Typography from '@mui/material/Typography';
import { Divider, Grid, Container,Card,CardMedia,CardContent,CardActions,Button } from '@mui/material';


export default function Producs() {

  return (
    <Container id="products"  maxWidth = {false}  component='main' sx={{backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundImage:'url("https://firebasestorage.googleapis.com/v0/b/demos-a64ab.appspot.com/o/landing%2Fbackgroun_services.png?alt=media&token=ce42a93d-fdc6-424d-a002-5fafb995da19")'}}>
     
      <Typography component="p" variant="subtitle2" align="center" color="text.secondary"  sx={{my:8}}>
          Products
      </Typography>
      <Grid container columns={12} sx={{pt:8,pb:2}} spacing={2} alignItems="center" >  
          <Grid item xs={12} md ={12} sm={12} align="center" >  
            <Typography component="p"  variant="h3" align="center"  color="primsary" >
              Soluciones de Movilidad Inteligente
            </Typography>
            <Typography sx={{pt:8}} component="p"  variant="body1" align="center"  color="text.secondary" >
              Solución para ingresar a estacionamientos de plazas y centros comerciales. Los clientes pueden disfrutar del tiempo de tolerancia y realizar el pago de su estancia directo en la App.
            </Typography>
          </Grid>
      </Grid>
      
      <Grid container columns={12} sx={{ xs:{m:16}, md: {m:8}, sm:{m:4}, lg:{mx:1, my:4}, xl:{m:8}, py:2}} spacing={2}>
          {[
            {title:"Effortless Access",description:"With our state-of-the-art app, find and reserve your perfect spot in seconds. Say hello to parking bliss!"},
          {title:"Guaranteed Security",description:" Your peace of mind is our top priority. Our locations are monitored 24/7, ensuring your vehicle's safety."},
          {title:"Competitive Rates",description:" Enjoy premium parking access without the premium price. Discover our flexible pricing options."}].map(element => (
          <Grid item xs={12} md ={4} sm={4} align="center" >  
              <Card sx={{ maxWidth: 400 }} variant='soft'>
                  <CardMedia
                      component="img"
                      alt="image"
                      height="140"
                      image="https://firebasestorage.googleapis.com/v0/b/demos-a64ab.appspot.com/o/landing%2Flogos_cqurity.webp?alt=media&token=35ba0be5-cf9c-46ac-8638-097a3a2b4c23"
                  />
                  <CardContent>
                      <Typography gutterBottom variant="h5" component="div">
                        {element.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {element.description}
                      </Typography>
                  </CardContent>
                  <CardActions sx={{justifyContent:"center"}}>
                      <Button size="small">Learn More</Button>
                  </CardActions>
              </Card>
          </Grid>
          ))}
      </Grid>
      
    </Container>
  );
}